import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonV3Component } from '@gea/digital-ui-lib';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-confirm-upload-dialog',
  imports: [ButtonV3Component, DividerModule],
  templateUrl: './confirm-file-replace-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmFileReplaceDialogComponent {
  constructor(private dialogRef: DynamicDialogRef) {}

  confirm(): void {
    this.dialogRef.close('Confirm');
  }

  reject(): void {
    this.dialogRef.close();
  }
}
